import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
import { storage, db } from "../../../firebase/firebaseConfig"; // Asegúrate de tener la configuración correcta
import { v4 as uuidv4 } from "uuid"; // Para generar un ID único para cada archivo
import { Box, Button, TextField, Typography, CircularProgress } from "@mui/material";

const UploadAudioForm = () => {
    // Estados para almacenar los datos del formulario
    const [audioFile, setAudioFile] = useState(null);
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [audioName, setAudioName] = useState("");
    const [author, setAuthor] = useState("");
    const [loading, setLoading] = useState(false);

    // Función que maneja la selección de archivos
    const handleAudioChange = (e) => {
        setAudioFile(e.target.files[0]);  // Guardar el archivo de audio en el estado
    };

    const handleThumbnailChange = (e) => {
        setThumbnailFile(e.target.files[0]);  // Guardar el archivo de imagen (miniatura) en el estado
    };

    // Función que maneja el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevenir el comportamiento por defecto del formulario
        if (!audioFile || !thumbnailFile || !audioName || !author) {
            alert("Por favor completa todos los campos");
            return;
        }

        try {
            setLoading(true); // Mostrar indicador de carga

            // Crear una referencia única para el archivo de audio
            const audioRef = ref(storage, `audios/${uuidv4()}-${audioFile.name}`);
            const thumbnailRef = ref(storage, `thumbnails/${uuidv4()}-${thumbnailFile.name}`);

            // Subir el archivo de audio a Firebase Storage
            const audioSnapshot = await uploadBytes(audioRef, audioFile);
            const audioURL = await getDownloadURL(audioSnapshot.ref);

            // Subir el archivo de imagen (miniatura) a Firebase Storage
            const thumbnailSnapshot = await uploadBytes(thumbnailRef, thumbnailFile);
            const thumbnailURL = await getDownloadURL(thumbnailSnapshot.ref);

            // Guardar la metadata en Firebase Firestore
            const audioData = {
                name: audioName,
                author: author,
                audioURL: audioURL,
                thumbnailURL: thumbnailURL,
                createdAt: new Date()
            };

            // Aquí es donde corregimos el uso de "firestore" en lugar de "storage"
            await addDoc(collection(db, "milistacancionescalocho"), audioData);  // Agregar los datos a Firestore

            alert("Audio subido exitosamente");
            setAudioFile(null); // Reiniciar el archivo de audio
            setThumbnailFile(null); // Reiniciar el archivo de imagen
            setAudioName(""); // Reiniciar el nombre
            setAuthor(""); // Reiniciar el autor

        } catch (error) {
            console.error("Error al subir el archivo:", error);
            alert("Hubo un error al subir el archivo. Inténtalo de nuevo.");
        } finally {
            setLoading(false); // Ocultar indicador de carga
        }
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                width: '100%',
                maxWidth: 500,
                margin: 'auto',
                padding: 2,
                boxShadow: 3,
                borderRadius: 2,
                background: '#ffffff'
            }}
        >
            
            <Typography variant="h5">Subir Audio</Typography>

            <TextField
                label="Nombre del Audio"
                value={audioName}
                onChange={(e) => setAudioName(e.target.value)}
                size="small"
                fullWidth
                required
            />

            <TextField
                label="Autor o Intérprete"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                fullWidth
                size="small"
                required
            />

            <Button variant="outlined" size="small" component="label" fullWidth>
                Selecciona Archivo de Audio
                <input type="file" accept="audio/*" hidden onChange={handleAudioChange} />
            </Button>

            <Button variant="outlined" size="small" component="label" fullWidth>
                Selecciona Imagen de Miniatura
                <input type="file" accept="image/*" hidden onChange={handleThumbnailChange} />
            </Button>

            {loading ? (
                <CircularProgress />
            ) : (
                <Button variant="outlined" size="small" color="primary" type="submit" fullWidth>
                    Subir Audio
                </Button>
            )}
        </Box>
    );
};

export default UploadAudioForm;